import { render, staticRenderFns } from "./CardOrderCreateModal.vue?vue&type=template&id=4852b7c9"
import script from "./CardOrderCreateModal.vue?vue&type=script&lang=js"
export * from "./CardOrderCreateModal.vue?vue&type=script&lang=js"
import style0 from "./CardOrderCreateModal.vue?vue&type=style&index=0&id=4852b7c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports